<template>
  <SideHeader :to="'/profile'" />
  <div style="padding-top: 55px;">
    <div class="section full mt-2 mb-2">
      <div class="section-title">
        <span>انتقادات و شکایات</span>
        <!-- <router-link class="item" active-class='active' to="/"> -->
        <span>
          <router-link to="/feedbackFollow">پیگیری شکایات</router-link>
        </span>
      </div>
      <div class="wide-block pt-2 pb-3">
        <form>
          <div class="form-group basic animated">
            <div class="input-wrapper">
              <label class="label" for="title">عنوان</label>
              <input type="text" class="form-control" id="title" v-model.lazy.trim="postData.title" required />
              
              <div v-if="postData.titleErrorText" class="text-danger">اجباری</div>
            </div>
          </div>

          <div class="form-group basic animated">
            <div class="input-wrapper">
              <label class="label" for="message">پیام شما</label>
              <textarea class="form-control" v-model.lazy.trim="postData.message" name="message" rows="3"></textarea>
              <div v-if="postData.messageErrorText" class="text-danger">اجباری</div>
              
            </div>
          </div>
          <div class="form-group basic animated">
            <div class="input-wrapper">
              <label class="form-label" for="captchaValue">
                کد امنیتی
              </label>
              <input
                id="captchaValue"
                type="tel"
                class="form-control text-start"
                placeholder="کد امنیتی"
                v-model="captchaValue"
                maxlength="5"
              />
            </div>
          </div>

          <div class="form-group boxed">
            <div class="input-wrapper">
              <Captcha @toggle-favorite="captchaEmit"/>
            </div>
          </div>

          <div class="mt-2">
            <button v-if="loading == 0" @click.prevent="validation" class="btn background-blue text-light btn-block"
              type="submit">
              ارسال
            </button>
            <button v-else class="btn background-blue text-light btn-block" type="button" disabled="">
              <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
              درحال بارگذاری ...
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- <Footer /> -->
</template>

<script>
import Captcha from "@/components/Captcha.vue";
import SideHeader from "@/components/SideHeader.vue";
import axios from "axios";
import Swal from "sweetalert2";
import { reactive, ref } from "vue";

export default {
  name: "feedback",
  components: {
    SideHeader,
    Captcha
  },
  data() {
    return {
      captchaCurrent: '',
      captchaValue: ''
    };
  },
  setup() {
    const postData = reactive({
      title: "",
      message: "",
      phoneNumber: "",
      titleErrorText: "",
      messageErrorText: "",
      phoneNumberErrorText: "",
    });
    const loading = ref(false);


    function validation() {
      if (postData.title === "") {
        postData.titleErrorText = "عنوان اجباری است";
      }
      if (postData.message === "") {
        postData.messageErrorText = "متن اجباری است";
      }
      if (postData.title != "") {
        createPost();
      }
    }

    function createPost() {
      // console.log(postData);
      const axiosConfig = {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      };
      loading.value = 1;
      axios
        .post(`https://xpanel.s-bar.ir/api/driver/storeComplaintDriver`,
          postData, axiosConfig
        )
        .then((response) => {
          loading.value = 0;
          Swal.fire({
            title: `کد پیگیری: ${response.data.data.trackingCode}`,
            text: "پیام شما برای تیم پشتیبانی ارسال شد!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "حله",
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload();
            }
          });
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    }
    return { postData, createPost, validation, loading };
  },
  methods: {
    captchaEmit(value) {
      this.captchaCurrent = value;
    }
  }
};
</script>

<style scoped></style>